import { Flex, Spin, Text } from "@gravity-ui/uikit";
import { useRef } from "react";
import Skeleton from "react-loading-skeleton";
import { InfinityScroll } from "src/components";

import { useProductPageTranslate } from "../../hooks/useProductPageTranslate";
import { ProductTableData } from "../../store/fetchers";
import { ProductCard } from "../ProductCard/ProductCard";
import css from "./ProductCards.module.scss";

interface ProductCardsProps {
  products: ProductTableData[];
  onClick?: (product: ProductTableData) => void;
  onLoadMore: () => void;
  isLoading?: boolean;
  isFetchLoading?: boolean;
  hasNext?: boolean;
}

export const ProductCards = ({
  products,
  onClick,
  onLoadMore,
  isLoading,
  isFetchLoading,
  hasNext,
}: ProductCardsProps) => {
  const { noMoreProducts } = useProductPageTranslate();

  // NOTE: Продукты могут повторятся, по этому сделали счетчик повторений для уникализации ключа
  const counterMapRef = useRef(new Map());

  if (isLoading)
    return (
      <Skeleton
        count={20}
        inline
        width={150}
        height={150}
        containerClassName={css.skeletonContainer}
        className={css.skeletonCard}
      />
    );

  return (
    <InfinityScroll
      className={css.cardContainer}
      disabled={isFetchLoading || !hasNext}
      loadMore={onLoadMore}
    >
      <div className={css.cardWrapper}>
        {products.map((product) => {
          const key = `${product.id}`;
          const count = counterMapRef.current.get(key) || 0;
          counterMapRef.current.set(key, count + 1);

          return (
            <ProductCard
              key={`${key}-${count}`}
              product={product}
              onClick={onClick}
            />
          );
        })}
      </div>

      {isFetchLoading && (
        <Flex
          justifyContent={"center"}
          alignItems={"center"}
          height={86}
          width={"100%"}
        >
          <Spin size="xl" />
        </Flex>
      )}
      {!isFetchLoading && !hasNext && (
        <Text variant="subheader-2">{noMoreProducts}</Text>
      )}
    </InfinityScroll>
  );
};
